export const setRecords = {
  SET_RECORDS(state, payload) {
    state.records = payload;
  }
};
